import React from 'react';

export default function Template() {
  return (
    <div>
      <p>
        For the purposes of this declaration, a HNWI means an individual whose total current net assets are equal to or
        exceed USD 5,000,000 (Five Million US Dollars) or the equivalent in any other currency.
      </p>
    </div>
  );
}
